import { SkillData } from "../../models/SkillData";

export const otherSkills: SkillData[] = [
  {
    name: "Git",
    img: "https://user-images.githubusercontent.com/25181517/192108372-f71d70ac-7ae6-4c0d-8395-51d8870c2ef0.png",
  },
  {
    name: ".NET Core",
    img: "https://user-images.githubusercontent.com/25181517/121405754-b4f48f80-c95d-11eb-8893-fc325bde617f.png",
  },
  {
    name: "Unity",
    img: "https://user-images.githubusercontent.com/25181517/193427941-9437dbbe-376f-40dc-9573-0ef5c02a26a7.png",
  },
  {
    name: "C++",
    img: "https://user-images.githubusercontent.com/25181517/192106073-90fffafe-3562-4ff9-a37e-c77a2da0ff58.png",
  },
  {
    name: "C#",
    img: "https://user-images.githubusercontent.com/25181517/121405384-444d7300-c95d-11eb-959f-913020d3bf90.png",
  },
];
